import ActiveManageScreen from "./_active_manage_screen.js";

export default [
  {
    path: "index",
    component: resolve =>
      require(["../views/active/manage/activeInfo/index.vue"], resolve)
  },
  {
    path: "edit",
    component: resolve =>
      require(["../views/active/manage/activeInfo/edit.vue"], resolve)
  },
  {
    path: "channel",
    component: resolve =>
      require(["../views/active/manage/activeInfo/channel.vue"], resolve)
  },
  {
    path: "market",
    component: resolve =>
      require(["../views/active/manage/activeInfo/market.vue"], resolve)
  },
  {
    path: "xiezuo",
    component: resolve =>
      require(["../views/active/manage/activeInfo/xiezuo.vue"], resolve)
  },
  {
    path: "ticket",
    component: resolve =>
      require(["../views/active/manage/ticket/index.vue"], resolve)
  },
  {
    path: "signUpForm",
    component: resolve =>
      require(["../views/active/manage/ticket/TicketForm.vue"], resolve)
  },
  {
    path: "schedule",
    component: resolve =>
      require(["../views/active/manage/schedule/schedule-manage.vue"], resolve)
  },
  {
    path: "picture",
    component: resolve =>
      require(["../views/active/manage/schedule/picture-data.vue"], resolve)
  },
  {
    path: "file",
    component: resolve =>
      require(["../views/active/manage/schedule/file-data.vue"], resolve)
  },
  {
    path: "movie",
    component: resolve =>
      require(["../views/active/manage/schedule/movie.vue"], resolve)
  },
  {
    path: "guest",
    component: resolve =>
      require(["../views/active/manage/schedule/guest-manage.vue"], resolve)
  },
  {
    path: "hall",
    component: resolve =>
      require(["../views/active/manage/schedule/hall-manage.vue"], resolve)
  },
  {
    path: "pc",
    component: resolve =>
      require(["../views/active/manage/design/pc-design.vue"], resolve)
  },
  {
    path: "phone",
    component: resolve =>
      require(["../views/active/manage/design/micro-website.vue"], resolve)
  },
  {
    path: "person",
    component: resolve =>
      require(["../views/active/manage/personlist/person-list.vue"], resolve)
  },
  {
    path: "liaisons",
    component: resolve =>
      require(["../views/active/manage/personlist/liaisons.vue"], resolve)
  },
  {
    path: "signPoint",
    name: "signPoint",
    component: resolve =>
      require(["../views/active/manage/interaction/SignPoint.vue"], resolve)
  },
  {
    path: "signPoint/personList/:pointId",
    name: "signPoint/personList",
    component: resolve =>
      require([
        "../views/active/manage/interaction/signPoint/PersonList.vue"
      ], resolve)
  },
  {
    path: "wechat",
    name: "activeWechat",
    component: resolve =>
      require(["../views/active/manage/interaction/WeChat.vue"], resolve)
  },
  {
    path: "wechat/page/:signinId",
    name: "activeWechatPage",
    component: resolve =>
      require([
        "../views/active/manage/interaction/weChat/signup-manage.vue"
      ], resolve)
  },
  {
    path: "wechat/:signinId",
    name: "activeWechatBasic",
    component: resolve =>
      require([
        "../views/active/manage/interaction/weChat/sign-basic.vue"
      ], resolve)
  },
  {
    path: "wechat/success/:signinId",
    name: "activeWechatSuccess",
    component: resolve =>
      require([
        "../views/active/manage/interaction/weChat/sign-success-configure.vue"
      ], resolve)
  },
  {
    path: "wechat/history/:signinId",
    name: "activeWechatHistory",
    component: resolve =>
      require([
        "../views/active/manage/interaction/weChat/sing-history-list.vue"
      ], resolve)
  },
  {
    path: "screen",
    name: "activeScreen",
    component: resolve =>
      require(["../views/active/manage/interaction/big-screen.vue"], resolve)
  },
  {
    path: "screen/:screenid",
    name: "activeScreenManage",
    redirect: "/menu/active-center/management/:id/screen/:screenid/basic",
    component: resolve =>
      require([
        "../views/active/manage/interaction/bigScreenManage/screen-common.vue"
      ], resolve),
    children: ActiveManageScreen
  },
  {
    path: "live",
    name: "livelist",
    component: resolve =>
      require(["../views/active/manage/interaction/LiveList.vue"], resolve)
  },
  {
    // 直播配置
    path: "live/:liveid",
    name: "liveInfo",
    component: resolve =>
      require([
        "../views/active/manage/interaction/liveData/index.vue"
      ], resolve)
  },
  {
    path: "resource",
    component: resolve =>
      require(["../views/active/manage/resource/resource.vue"], resolve)
  },
  {
    path: "report",
    component: resolve =>
      require(["../views/active/manage/report/PersonReport.vue"], resolve)
  },
  {
    path: "sharereport",
    component: resolve =>
      require(["../views/active/manage/report/ShareReport.vue"], resolve)
  },
  {
    path: "xiezuoreport",
    component: resolve =>
      require(["../views/active/manage/report/xiezuo.vue"], resolve)
  },
  {
    path: "shareranking",
    component: resolve =>
      require(["../views/active/manage/report/ShareRanking.vue"], resolve)
  },
  {
    path: "sharereport/sharereportdetail/:code",
    component: resolve =>
      require(["../views/active/manage/report/ShareReportDetail.vue"], resolve)
  }
];
